import React, { useCallback } from 'react';
import Dropbox from './components/dropbox';
import { FileWithPath } from 'react-dropzone';
import { SxProps } from '@mui/material';
import FolderSupportDropboxInner from 'shared/lib/components/controls/uploadArea/components/folderSupportDropboxInner';

export type UploadedFile = {
  originalFile: File;
};
export type UploadedReadedFile = {
  dataUrl: string;
  originalFile: File;
};

export default function UploadFolderArea({
  handleAddFile,
  text,
  buttonText,
  icon,
  sx,
  innerSx,
  error,
  triggerMode,
}: {
  handleAddFile: (image: UploadedFile) => void;
  text?: string;
  buttonText?: string;
  icon?: React.ReactNode;
  sx?: SxProps;
  innerSx?: SxProps;
  error?: boolean;
  triggerMode?: boolean;
}) {
  const onDrop = useCallback(
    (acceptedFiles: FileWithPath[]) => {
      acceptedFiles.forEach((file, index) => {
        handleAddFile({
          originalFile: file,
        } as UploadedFile);
      });
    },
    [handleAddFile]
  );

  const errorSx = error
    ? {
        borderColor: 'error.main',
      }
    : {};

  return (
    <Dropbox sx={{ ...sx }}>
      <FolderSupportDropboxInner
        sx={{ ...errorSx, ...innerSx }}
        text={text}
        buttonText={buttonText}
        icon={icon}
        onDrop={onDrop}
        triggerMode={triggerMode}
      ></FolderSupportDropboxInner>
    </Dropbox>
  );
}
